import { makeStyles } from "@material-ui/core";
import { fade } from '@material-ui/core/styles/colorManipulator';

export const useStyles = makeStyles((theme) => ({
  sacola: { height: '35px' },
  badge: { bottom: '5px', right: 0 },
  badgeIcon: { bottom: '5px', right: 0 },
  carrinhoIcon: {
    height: '30px',
    width: '30px',
    fill: theme.palette.primary.contrastText,
    padding: 0,
    margin: 0
  },
  btnCarrinho: {
    fontSize: 16,
  },
  root: {
    justifyContent: 'flex-start',
    textAlign: 'initial',
    padding: theme.spacing(0, 2),
    textTransform: 'none',
    '&:hover': {
      background: fade(theme.palette.background.paper, 0.75),
    }
  },
  attentionBall: {
    position: 'relative',
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    marginLeft: theme.spacing(1.5),
    '&::after': {
      content: '""',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: 20,
      height: 20,
      borderRadius: '50%',
      boxShadow: `0 0 0 0 ${fade(theme.palette.primary.main, 0.7)}`,
      animation: '$pulseRing 1.6s ease-out infinite',
    },
  },
  '@keyframes pulseRing': {
    '0%': {
      boxShadow: `0 0 0 0 ${fade(theme.palette.primary.main, 0.6)}`,
    },
    '70%': {
      boxShadow: `0 0 0 14px ${fade(theme.palette.primary.main, 0)}`,
    },
    '100%': {
      boxShadow: `0 0 0 0 ${fade(theme.palette.primary.main, 0)}`,
    },
  },
  container: {
    position: 'fixed',
    top: theme.spacing(14),
    left: 0,
    zIndex: 100,
    width: '100%',
  },
  gridContainer: {
    '& > div': {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }
  },
  btn: {
    minHeight: 64,
    borderRadius: theme.shape.borderRadius,
    background: fade(theme.palette.background.paper, 0.85),
    border: `1px solid ${theme.palette.primary.main}`,
    backdropFilter: 'blur(5px)',
  }
}));